import $ from 'jquery';
import {
    matchMediaQuery,
} from '../../scripts/helpers';

const filterV2Semantics = {
    'mainWrapClass': 'catalog-filtered-grid',
    'mobileBarClass': 'catalog-filtered-grid__common-wrap',
    'mobileBarCloseSelectors': [
        '.catalog-filtered-grid__header-close-icon',
        '.catalog-filtered-grid__header-close-icon use',
        '.catalog-filtered-grid__common-wrap',
    ],
    'toggleClass': 'filter-toggle-v1__wrap',
    'toggleTextClass': 'filter-toggle-v1__text',
    'toggleLabelOffAttribute': 'data-label-off',
    'toggleLabelOnAttribute': 'data-label-on',
    'showFilterBarClass': 'catalog-filtered-grid_is-show-filter',
    'mobileFilterBarModifier': 'catalog-filtered-grid_mobile',
    'mobileClosingModifierClasses': [
        // click onclose button in head filter
        'catalog-filtered-grid__header-close-icon',
        // or opacity bg for tablet
    ],
    'pageRootElementSelector': 'body',
    'filterOptionClass': 'catalog-filtered-grid__filter-option',
    'filterOptionActiveModifier': 'catalog-filtered-grid__filter-option_is-active',
    'checkboxV1WrapClass': 'checkbox-v1__wrap',
    'checkboxV1BoxClass': 'checkbox-v1__checkbox',
    'filterBlockClass': 'catalog-filtered-grid__filter-block',
    'filterBlockHeaderClass': 'catalog-filtered-grid__filter-head-wrap',
    'filterBlockOpenModifier': 'catalog-filtered-grid__filter-block_is-open',
    // TODO[task]: FIlterBlockSelectVendorV2 - search input
    // make a separate component for the widget
    'vendorFilteredWrapSelector': '.filter-block-select-vendor-v2 .catalog-filtered-grid__filter-options',
    'vendorFilteredInputSelector': '.filter-block-select-vendor-v2 .catalog-filtered-grid__filter-search .text-input-v1',
    'vendorFilteredElementClass': 'catalog-filtered-grid__filter-option',
    'vendorFilteredElementChildSelector': '.checkbox-v1__label',
    'vendorFilteredInputCloseWrapClass': 'catalog-filtered-grid__filter-search-close', // add position: relative
    'vendorFilteredInputCloseIconClass': 'catalog-filtered-grid__filter-search-close-icon'
};

$(() => {
    // for only page with widget
    if ($(`.${filterV2Semantics.mainWrapClass}`).length > 0) {
        // popoverTracker for mobile and tablet (to landscape orientation)
        // TODO[task]: all breakpointRange, use max-width - it needs to be shifted by a few hundredths
        // @see https://getbootstrap.com/docs/5.0/layout/breakpoints/ [search by Why subtract .02px?]
        if (matchMediaQuery('(max-width: 1023.98px)')) {
            let tracker = new FilterTracker('toggleMobile');
        } else {
            let tracker = new FilterTracker('toggleDesktop');
        }
    }
});

/**
 * Base filter tracker
 */
class FilterTracker
{
    // not install @babel/plugin-proposal-class-properties
    // init properties in constructor

    constructor(toggleMethod) {
        this.toggleMethod = toggleMethod;
        this.mainWrap = $(`.${filterV2Semantics.mainWrapClass}`);
        this.toggle = $(`.${filterV2Semantics.toggleClass}`);
        this.mobileBar = $(`.${filterV2Semantics.mobileBarClass}`);
        if (!this.mainWrap.length) {
            throw new Error("Semantic error in the filter bar widget!")
        }
        this.subscribe();
    }

    /**
     * Add common listener to events
     * @return void
     */
    subscribe() {
        let self = this;
        // toggle filter block
        $(`.${filterV2Semantics.filterBlockHeaderClass}`).on('click', function(e) {
            let filterBlock = $(e.target).parents(`.${filterV2Semantics.filterBlockClass}`);
            if (filterBlock) {
                if (filterBlock.hasClass(filterV2Semantics.filterBlockOpenModifier)) {
                    filterBlock.removeClass(filterV2Semantics.filterBlockOpenModifier);
                } else {
                    filterBlock.addClass(filterV2Semantics.filterBlockOpenModifier);
                }
            }
        });
        // toggle filter bar
        $('body').on('click',`.${filterV2Semantics.toggleClass}`, function(e) {
                self[self.toggleMethod]();
            }
        );
        // close
        $(`${filterV2Semantics.mobileBarCloseSelectors.join(', ')}`).on(
            'click', 
            function(e) {
                if ($(e.target).hasClass('catalog-filtered-grid__header-close-icon')
                    || $(e.target).parents('.catalog-filtered-grid__header-close-icon').length > 0) {
                    self[self.toggleMethod]();
                    return false;
                }
                if ($(e.target).is(
                    filterV2Semantics.mobileBarCloseSelectors.join(', ')
                )) {
                    self[self.toggleMethod]();
                }
            }
        );
        // reset menu status on resize window,
        $(window).on('resize', function() {
            if (matchMediaQuery('(max-width: 1023.98px)')) {
                self.toggleMethod = 'toggleMobile';
            } else {
                self.toggleMethod = 'toggleDesktop';
            }
            self.closeMobile();
        });
        // follow the checkboxes in filter-option and switch the activating class
        $(`.${filterV2Semantics.filterOptionClass} > ` +
        `.${filterV2Semantics.checkboxV1WrapClass} > ` +
        `.${filterV2Semantics.checkboxV1BoxClass}`).on('change', function(e) {
            let checkbox = $(e.target);
            let wrap = checkbox.parents(`.${filterV2Semantics.filterOptionClass}`);
            if (wrap) {
                if (checkbox.is(':checked')) {
                    wrap.removeClass(filterV2Semantics.filterOptionActiveModifier);
                    wrap.addClass(filterV2Semantics.filterOptionActiveModifier);
                } else {
                    wrap.removeClass(filterV2Semantics.filterOptionActiveModifier);
                }
            }
        });
    }

    /**
     * Toggle mobile
     * @return void
     */
    toggleMobile() {
        if (this.mainWrap.hasClass(filterV2Semantics.showFilterBarClass)) {
            this.closeMobile();
        } else {
            this.openMobile();
        }
    }

    /**
     * Toggle desktop
     * @return void
     */
    toggleDesktop() {
        if (this.mainWrap.hasClass(filterV2Semantics.showFilterBarClass)) {
            this.closeDesktop();
        } else {
            this.openDesktop();
        }
    }

    /**
     * Close menu on desktop
     * @return void
     */
    closeDesktop() {
        this.mainWrap.removeClass(filterV2Semantics.showFilterBarClass);
        this.toggle.find(`.${filterV2Semantics.toggleTextClass}`)
            .empty().text(
                this.toggle.attr(filterV2Semantics.toggleLabelOffAttribute)
            );
    }

    /**
     * Open menu on desktop
     * @return void
     */
    openDesktop() {
        this.mainWrap.addClass(filterV2Semantics.showFilterBarClass);
        this.toggle.find(`.${filterV2Semantics.toggleTextClass}`)
            .empty().text(
                this.toggle.attr(filterV2Semantics.toggleLabelOnAttribute)
            );
    }

    /**
     * Close menu on mobile
     * @return void
     */
    closeMobile() {
        this.mainWrap.removeClass(filterV2Semantics.showFilterBarClass);
        this.mainWrap.removeClass(filterV2Semantics.mobileFilterBarModifier);
        this.mobileBar.css({
            'top': 'auto',
        });
        this.toggle.find(`.${filterV2Semantics.toggleTextClass}`)
            .empty().text(
                this.toggle.attr(filterV2Semantics.toggleLabelOffAttribute)
            );
        // clear scroll-bar for root-page element
        $(`${filterV2Semantics.pageRootElementSelector}`).css({
            'overflow': 'auto',
        });
        $('.sticky-footer').toggle();
    }

    /**
     * Open menu on mobile
     * @return void
     */
    openMobile() {
        this.mainWrap.addClass(filterV2Semantics.showFilterBarClass);
        this.mainWrap.addClass(filterV2Semantics.mobileFilterBarModifier);
        this.mobileBar.css({
            'top': $(document).scrollTop(),
        });
        this.toggle.find(`.${filterV2Semantics.toggleTextClass}`)
            .empty().text(
                this.toggle.attr(filterV2Semantics.toggleLabelOnAttribute)
            );
        // clear scroll-bar for root-page element
        $(`${filterV2Semantics.pageRootElementSelector}`).css({
            'overflow': 'hidden',
        });
        $('.sticky-footer').toggle();
    }
};